module.exports = __webpack_public_path__ + "media/images/activity-indicator-dark-5539cd3490c11473378e30f4976ff71a.svg";